module.exports = __webpack_public_path__ + "static/media/6319046-394x394.5bb5e8f2.jpg";